module.exports = __webpack_public_path__ + "img/账户安全.0d580397.svg";